// Configuration file for environment variables and API settings
export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || (process.env.NODE_ENV === 'production' ? 'https://portal.infrasec.se/api' : ''),
    timeout: 10000, // 10 seconds
    endpoints: {
      login: process.env.REACT_APP_LOGIN_ENDPOINT || '/login',
      logout: process.env.REACT_APP_LOGOUT_ENDPOINT || '/logout',
      refreshToken: process.env.REACT_APP_REFRESH_TOKEN_ENDPOINT || '/refresh',
      company: process.env.REACT_APP_COMPANY_ENDPOINT || '/company',
      user: process.env.REACT_APP_USER_ENDPOINT || '/user',
      verifyUser: process.env.REACT_APP_VERIFY_USER_ENDPOINT || '/verify/user',
      testSuitesByCompany: process.env.REACT_APP_TEST_SUITES_BY_COMPANY_ENDPOINT || '/getTestSuitesByCompany',
      createTestSuite: process.env.REACT_APP_CREATE_TEST_SUITE_ENDPOINT || '/createTestSuite',
      testDetails: process.env.REACT_APP_TEST_DETAILS_ENDPOINT || '/getTestDetails',
      updateTest: process.env.REACT_APP_UPDATE_TEST_ENDPOINT || '/updateTest',
      uploadReceipt: process.env.REACT_APP_UPLOAD_RECEIPT_ENDPOINT || '/uploadReceipt',
      documents: process.env.REACT_APP_DOCUMENTS_ENDPOINT || '/documents',
      documentsGeneral: process.env.REACT_APP_DOCUMENTS_GENERAL_ENDPOINT || '/documents/general',
      documentsCompany: process.env.REACT_APP_DOCUMENTS_COMPANY_ENDPOINT || '/documents/company',
      notifications: process.env.REACT_APP_NOTIFICATIONS_ENDPOINT || '/notifications',
      markNotificationRead: process.env.REACT_APP_MARK_NOTIFICATION_READ_ENDPOINT || '/notifications',
      certifications: process.env.REACT_APP_CERTIFICATIONS_ENDPOINT || '/getCertifications',
      forgotPassword: process.env.REACT_APP_FORGOT_PASSWORD_ENDPOINT || '/forgot-password',
      resetPassword: process.env.REACT_APP_RESET_PASSWORD_ENDPOINT || '/forgot-password/verification',
      sendEmail: process.env.REACT_APP_SEND_EMAIL_ENDPOINT || '/emails/send',
      exportActiveUsers: process.env.REACT_APP_EXPORT_ACTIVE_USERS_ENDPOINT || '/exports/active-users.csv',
    }
  },
  auth: {
    tokenKey: 'infrasec_auth_state',
    encryptionKey: process.env.REACT_APP_ENCRYPTION_KEY || 'infrasec-encryption-key-2025',
  },
  app: {
    name: 'Infrasec Frontend',
    version: '1.0.0',
    debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
    logLevel: process.env.REACT_APP_LOG_LEVEL || 'error',
  }
} as const;

export default config;
